import React from 'react';

interface MedicationCardProps {
  name: string;
  dosage: string;
  time: string;
  status: 'upcoming' | 'administered' | 'overdue';
  imageUrl?: string;
}

export const MedicationCard: React.FC<MedicationCardProps> = ({ name, dosage, time, status, imageUrl }) => {
  const statusConfig = {
    upcoming: { label: 'Upcoming', color: '#1976d2' },
    administered: { label: '✓ Administered', color: '#2e7d32' },
    overdue: { label: '⚠ Overdue', color: 'red' },
  };

  const { label, color } = statusConfig[status];

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: 16,
        backgroundColor: '#fff',
        borderRadius: 8,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        marginBottom: 12,
        gap: 16,
      }}
    >
      {imageUrl && (
        <img src={imageUrl} alt={`${name} pill`} style={{ width: 48, height: 48, borderRadius: 8, objectFit: 'cover' }} />
      )}
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, fontSize: 18 }}>{name}</div>
        <div style={{ color: '#666', fontSize: 14 }}>{dosage}</div>
      </div>
      <div style={{ textAlign: 'right' }}>
        <div style={{ fontSize: 16, fontWeight: 500 }}>{time}</div>
        <div style={{ fontSize: 14, color, fontWeight: 500 }}>{label}</div>
      </div>
    </div>
  );
};
